import { renderSlot as _renderSlot, createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, normalizeClass as _normalizeClass, toDisplayString as _toDisplayString, createCommentVNode as _createCommentVNode, createTextVNode as _createTextVNode, TransitionGroup as _TransitionGroup, withCtx as _withCtx, createVNode as _createVNode, resolveComponent as _resolveComponent, mergeProps as _mergeProps, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-1a55fcd5"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "alert alert-primary text-center" }
const _hoisted_2 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", { class: "fas fa-grip-vertical" }, null, -1))
const _hoisted_3 = [
  _hoisted_2
]
const _hoisted_4 = { class: "ms-1 p-1 me-auto" }
const _hoisted_5 = ["disabled", "onChange"]
const _hoisted_6 = ["value", "selected"]
const _hoisted_7 = { class: "ms-2" }
const _hoisted_8 = ["value", "onKeyup"]
const _hoisted_9 = {
  key: 0,
  class: "pt-2 me-2"
}
const _hoisted_10 = ["checked", "onChange"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_draggable = _resolveComponent("draggable")!

  return (_openBlock(), _createElementBlock("div", null, [
    _createElementVNode("div", _hoisted_1, [
      _renderSlot(_ctx.$slots, "banner", {}, undefined, true)
    ]),
    _createVNode(_component_draggable, _mergeProps({
      modelValue: this.list,
      "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((this.list) = $event)),
      handle: ".drag-handle",
      move: _ctx.onMoveCheck
    }, _ctx.dragOptions, { onChange: _ctx.onDrop }), {
      default: _withCtx(() => [
        _createVNode(_TransitionGroup, {
          type: "transition",
          name: "flip-list"
        }, {
          default: _withCtx(() => [
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.sortAsc(this.list), (item) => {
              return (_openBlock(), _createElementBlock("div", {
                class: _normalizeClass(["input-group mb-2 input-group-row", _ctx.isActive(item.isHidden) ? 'disabled' : '']),
                key: item.id
              }, [
                _createElementVNode("span", {
                  class: _normalizeClass(["input-group-text", _ctx.isActive(item.isHidden) ? '' : 'drag-handle'])
                }, _hoisted_3, 2),
                _createElementVNode("div", _hoisted_4, [
                  _createElementVNode("select", {
                    class: "form-select form-select-sm d-inline-block",
                    disabled: _ctx.isActive(item.isHidden) === true,
                    onChange: ($event: any) => (_ctx.onSortChange(item.order, $event))
                  }, [
                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(this.list.length, (option, idx) => {
                      return (_openBlock(), _createElementBlock("option", {
                        value: idx + 1,
                        selected: _ctx.isSelected(idx + 1, item.order),
                        key: idx
                      }, _toDisplayString(idx + 1), 9, _hoisted_6))
                    }), 128))
                  ], 40, _hoisted_5),
                  _createElementVNode("span", _hoisted_7, [
                    _createTextVNode(_toDisplayString(item.name) + " ", 1),
                    (item.name === 'Custom Value')
                      ? (_openBlock(), _createElementBlock("input", {
                          key: 0,
                          class: "custom-input",
                          type: "text",
                          value: item.customValue,
                          onKeyup: ($event: any) => (_ctx.onCustomValueChange(item.order, $event))
                        }, null, 40, _hoisted_8))
                      : _createCommentVNode("", true)
                  ])
                ]),
                (_ctx.isCheckboxVisible)
                  ? (_openBlock(), _createElementBlock("div", _hoisted_9, [
                      _createElementVNode("input", {
                        type: "checkbox",
                        checked: !_ctx.isActive(item.isHidden),
                        onChange: ($event: any) => (_ctx.onCheckBoxChange(item.id, $event))
                      }, null, 40, _hoisted_10)
                    ]))
                  : _createCommentVNode("", true),
                _createElementVNode("div", {
                  class: _normalizeClass(["source-indicator", 'source-' + item.initials.toLowerCase()])
                }, null, 2)
              ], 2))
            }), 128))
          ]),
          _: 1
        })
      ]),
      _: 1
    }, 16, ["modelValue", "move", "onChange"])
  ]))
}